import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button,
  CreditCard
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";

///  <NUEVO PARA NOTIFICAR SIM>
import SweetAlert from "react-bootstrap-sweetalert";
///  </NUEVO PARA NOTIFICAR SIM>
import Iframe from "react-iframe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLastfmSquare } from "@fortawesome/free-brands-svg-icons";
import Fullscreen from "react-full-screen";
import Script from "react-load-script";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const CONFIRMAR_SIM = "SIM";
class TPV extends React.Component {
  constructor(props) {
    super(props);
    /* //console.log("########## PROPS ###########");
    //console.log(props); */
    this.state = {
      servicesSize: 4,
      ordersChartReady: false,
      ordersToDisplayInChart: 6,
      fieldStates: [],
      ICC: "",
      confirmICC: "", //ICC del envío
      fieldsToValidateSIMDelivery: ["ICC"],
      confirmingDelivery: "",
      currentApn: "",
      currentCompartir: "",
      isFull: false,

      cardNumber: "",
      expiryDate: "",
      cvc: ""
    };

    this.createMobileCards = this.createMobileCards.bind(this);
    this.addSize = this.addSize.bind(this);
    this.subSize = this.subSize.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateSIMDelivery = this.validateSIMDelivery.bind(this);
    this.createConfirmSIMDeliveryPopUp = this.createConfirmSIMDeliveryPopUp.bind(this);
    this.showPopUpConfirmation = this.showPopUpConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.createCurrentTools = this.createCurrentTools.bind(this);
    this.isToolSelected = this.isToolSelected.bind(this);
    this.goFull = this.goFull.bind(this);
  }
  componentDidMount() {
  }
  loadTPV() {
    // -- Listener de recepción de ID de operación --
    window.addEventListener("message", function receiveMessage(event) {
      window.storeIdOper(event, "token", "errorCode", true);
    });

    const [estiloBoton, estiloBody, estiloCaja, estiloInputs] = ["background-color:orange;color:black;","color:black;","color:grey;",";"];

    window.getInSiteForm("card-tpv-pago", estiloBoton, estiloBody, estiloCaja, estiloInputs, 'Texto botón pago', "999008881", "001", "06042020_insite_1");
    window.loadRedsysForm();
  }
  merchantValidationEjemplo() {
      //Insertar validaciones…
      return true;
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  validateICC(icc) {
    return icc === this.state.confirmICC.substring(this.state.confirmICC.length - 4);
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    switch (field) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          if (this.isNewIBAN(value)) {
            this.props.setCustomerIBAN(this.state.customer.id, value);
            this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      confirmICC: "",
      ICC: "",
      confirmingDelivery: "",
      fieldStates: []
    });
  }
  validateSIMDelivery() {
    let validation = true;
    this.state.fieldsToValidateSIMDelivery.map((item,key) => 
    {
      this.validateField(item, this.state[item]);
      if (this.state.fieldStates[item] === "has-danger") validation = false;
      if (!this.state[item] || this.state[item] === "") {
        validation = false;
      }
    });
    return validation;
  }
  deliverySIMConfirmation() {
    if (!this.validateSIMDelivery()) {
      return;
    }
    this.props.confirmSIMDelivery(this.state.confirmingDelivery);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block"/*, marginTop: "-250px" */}}
          title="¡Recepción confirmada!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          Hemos lanzado tu portabilidad, en 36-48h hábiles (sin contar festivos ni fines de semana) estará lista.
        </SweetAlert>
      )
    });
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case CONFIRMAR_SIM:
        this.deliverySIMConfirmation();
        break;
      default:;
    }
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case CONFIRMAR_SIM:
        return this.createConfirmSIMDeliveryPopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  createConfirmSIMDeliveryPopUp() {
    return (
      <SweetAlert
        style={{ display: "block"/*, marginTop: "-250px"*/ }}
        title="Confirmar SIM"
        onConfirm={() => this.showPopUpConfirmation(CONFIRMAR_SIM)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row className="text-center">
            <div style={{margin: "0 2em 1em 2em", textAlign: "justify"}}>
              <span>Para confirmar la recepción de la SIM, escribe los 4 últimos números de la ICC de la SIM (Los 4 últimos números del código de barras)</span>
            </div> 
            <Col xs={12} md={9}>
              <FormGroup className={this.state.fieldStates["ICC"]}>
                <Input
                  type="number"
                  value={this.state.ICC}
                  onChange={event => {
                    this.setState({ ICC: event.target.value.replace(/\s+/g, '') });
                    this.validateField("ICC", event.target.value.replace(/\s+/g, ''));
                  }}
              />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    }

    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        moment(currentOrder.fecha, "YYYY/MM/DD").format(
          "MMM YYYY"
        ) /* 
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        }) 
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")*/
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart
    });
  }
  addSize() {
    this.setState({
      servicesSize: this.state.servicesSize + 1
    });
  }
  subSize() {
    this.setState({
      servicesSize: this.state.servicesSize - 1
    });
  }
  createTableData() {
    var tableRows = [];
    for (var i = 0; i < table_data.length; i++) {
      tableRows.push(
        <tr key={i}>
          <td>
            <div className="flag">
              <img src={table_data[i].flag} alt="us_flag" />
            </div>
          </td>
          <td>{table_data[i].country}</td>
          <td className="text-right">{table_data[i].count}</td>
          <td className="text-right">{table_data[i].percentage}</td>
        </tr>
      );
    }
    return tableRows;
  }
  createMobileCards() {
    let mobileContent = null;
    if(this.props.mainState.hasMobile && this.props.mainState.mobilesLoaded){      
      mobileContent = this.props.mainState.mobiles.map((currentMobile, key) =>{
        return (
          <Col key={currentMobile.mobile} xs={12} md={this.state.servicesSize}>
            <Card className="card-stats card-raised">
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Link to={this.props.mainState.mobilesCDRLoaded ? "/movil/" + currentMobile.mobile : "/movil"}>
                      <Statistics
                        showIcon
                        iconState="primary"
                        icon="tech_mobile"
                        title={currentMobile.mobile.substring(0,3) + " " + currentMobile.mobile.substring(3,6) + " " + currentMobile.mobile.substring(6,9)}
                        subtitle={currentMobile.plan.replace(" (Móvil)", "")}
                      />
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    }else if(this.props.mainState.mobilesLoaded){
      mobileContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="tech_mobile"
                    title="Móviles"
                    subtitle="¡Trae tus móviles!"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }else{
      mobileContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Móviles"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }
    return mobileContent;
  }
  createToolsCards() {
    let toolsCards = [];
    let currentParams = this.props.match.params;
    let currentTool = null;
    if (Object.keys(this.props.match.params).length > 0) currentTool = currentParams.tool;
    
    let apnCard = 
        <Col key={"apnCard"} xs={12} md={this.state.servicesSize}>
        <Link to="/herramientas/apn">
            <Card className="card-stats card-raised" color={currentTool === "apn" ? "warning" : "white"}>
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Statistics
                      showIcon
                      iconState="primary"
                      icon="location_world"
                      title="Configurar APN"
                      subtitle="Configura Internet en tu móvil"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>;
    toolsCards.push(apnCard);
    
    let compartirDatos = 
        <Col key={"compartirDatos"} xs={12} md={this.state.servicesSize}>
          <Link to="/herramientas/compartir"> 
            <Card className="card-stats card-raised" color={currentTool === "compartir" ? "warning" : "white"}>
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Statistics
                      showIcon
                      iconState="info"
                      icon="ui-1_lock-circle-open"
                      title="Compartir datos"
                      subtitle="¿Quieres compartir tus datos?"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>;
    toolsCards.push(compartirDatos);
    
    let testVelocidadCard = 
        <Col key={"testVelocidadCard"} xs={12} md={this.state.servicesSize}>
          <Link to="/herramientas/test-velocidad"> 
            <Card className="card-stats card-raised" color={currentTool === "test-velocidad" ? "warning" : "white"}>
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Statistics
                      showIcon
                      iconState="danger"
                      icon="objects_spaceship"
                      title="Test de velocidad"
                      subtitle="¿Es rápida tu conexión?"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>;
    toolsCards.push(testVelocidadCard);

    return toolsCards;
  } 
  goFull = () => {
    this.setState({ isFull: true });
  }
  createCurrentTools() {
    let currentParams = this.props.match.params;
    if (!currentParams) return;
    let currentTool = null;
    let iframeToShow = null;
    iframeToShow = 
      <Card color="primary">
        <CardHeader>
          <CardTitle tag="h4" className="text-center" style={{color: "white"}}>
            <b>nadunet TV    </b>
            <Button onClick={this.goFull} color="info" size="sm">
              <FontAwesomeIcon icon={['fas', 'expand-arrows-alt']}  size="sm"/>
              {" "}Pantalla completa
            </Button>
          </CardTitle>
        </CardHeader>
        <CardBody>
          <Fullscreen
            enabled={this.state.isFull}
            onChange={isFull => this.setState({ isFull })}
          >
          <Row>
            <Iframe
              width="100%"
              height={window.innerHeight}
              frameBorder="0"
              src="https://player.masmediatv.es"
              className="full-screenable-node"
            />
          </Row>
          </Fullscreen>
        </CardBody>
      </Card>;
    currentTool = 
      <div>
        {iframeToShow}
      </div>;

    return currentTool;
  }
  isToolSelected() {
    if (this.props.match.params) {
      if (this.props.match.tool) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  render() {
    // console.log("######## PARAMS TOOLS ##########");
    // console.log(this.props.match.params);
    let toolsCards = this.createToolsCards();
    // let currentTool = this.createCurrentTools();
    let _isToolSelected = this.isToolSelected();
    return (
      <div>
        <Script
          url="https://sis-t.redsys.es:25443/sis/NC/sandbox/redsys2.js"
          // onCreate={this.handleScriptCreate.bind(this)}
          // onError={this.handleScriptError.bind(this)}
          onLoad={this.loadTPV.bind(this)}
        />
        <PanelHeader
          size="sm"
          content={
            <div>
              {/* <h6 style={dashboardOrdersTitleStyle}>Herramientas</h6> */}
            </div>
          }
        />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          <Row>
            {/* {!_isToolSelected && toolsCards} */}
            <Col xs={12} md={12}>
              {/* {currentTool} */}
              <Card className="card-stats card-raised">
                <CardBody>
                  <Row>
                    <Col xs={12} md={3}>
                      <CreditCard />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            {/* <Col md={12} xs={12}>
              {_isToolSelected && toolsCards}
            </Col> */}
          </Row>
          <Row>
            {/* {!_isToolSelected && toolsCards} */}
            <Col xs={12} md={12}>
              {/* {currentTool} */}
              <Card className="card-stats card-raised">
                <CardBody>
                  <Row>
                    <Col xs={12} md={12}>
                      <div id="card-tpv-pago" />
                      <input /*type="hidden"*/ id="token"></input>
                      <input /*type="hidden"*/ id="errorCode"></input>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            {/* <Col md={12} xs={12}>
              {_isToolSelected && toolsCards}
            </Col> */}
          </Row>
        </div>
      </div>
    );
  }
}

export default TPV;



// WEBPACK FOOTER //
// ./src/views/TPV/TPV.jsx